export const testimonials = [
  {
    id: 1,
    name: '김민지',
    occupation: '프리랜서 디자이너 · 33세',
    date: '2025년 11월',
    image: 'https://public.readdy.ai/ai/img_res/1d95f9f0415f30c9585fc9218c992f53.jpg',
    content: '솔직히 처음엔 반신반의했어요. 그냥 재미로 해볼까 했는데 사주팔자 결과를 보는 순간 소름이 돋았습니다. 일간이 을목(乙木)이라 유연하지만 내면이 강하다는 분석이 저한테 너무 딱 맞았거든요. 작년 말에 프리랜서로 전환할지 고민이 많았는데, 30년 운세 차트를 보니 2025~2027년이 커리어 전환의 최적기로 나오더라고요. 결국 전환했고 지금은 일도 잘 풀리고 있어요. 단순한 흥미를 넘어서 실질적인 인생 결정에 도움이 됐습니다.',
    rating: 5,
    highlight: '커리어 전환 결정에 실질적 도움',
  },
  {
    id: 2,
    name: '박준호',
    occupation: '스타트업 대표 · 38세',
    date: '2025년 9월',
    image: 'https://readdy.ai/api/search-image?query=confident%20asian%20businessman%20in%20his%20late%2030s%20with%20relaxed%20friendly%20smile%20wearing%20dark%20navy%20casual%20blazer%20clean%20shaved%20modern%20hairstyle%20warm%20office%20background%20soft%20lighting%20portrait&width=400&height=400&seq=testimonial-v2-2&orientation=squarish',
    content: '투자 라운드를 앞두고 타이밍을 언제로 잡을지 한참 고민하던 중에 지인 소개로 써봤어요. 재성(財星) 기운이 2025년 하반기에 집중된다는 분석이 나왔고, 실제로 그 시기에 맞춰 진행했더니 생각보다 빠르게 클로징됐습니다. 십신 분석에서 편재가 강하게 나온 것도 인상적이었어요. "사업수완과 유동재물"이라는 설명이 제 성향과 정확히 일치했거든요. 데이터 기반의 AI 분석인데도 전통 사주처럼 깊이가 있어서 놀랐습니다.',
    rating: 5,
    highlight: '투자 타이밍 결정에 정확한 분석',
  },
  {
    id: 3,
    name: '이서연',
    occupation: '대학원생 · 27세',
    date: '2026년 1월',
    image: 'https://readdy.ai/api/search-image?query=young%20asian%20graduate%20student%20woman%20mid%2020s%20bright%20cheerful%20smile%20wearing%20simple%20white%20turtleneck%20long%20straight%20black%20hair%20fresh%20academic%20look%20soft%20sky%20background%20portrait%20photography&width=400&height=400&seq=testimonial-v2-3&orientation=squarish',
    content: '졸업 후 진로를 완전히 바꿀까 고민하면서 이것저것 찾아보다가 DESTINY GPT를 써봤어요. 오행에서 수(水) 기운이 강하게 나왔는데 "지혜롭고 유연한 사고, 적응력이 뛰어나다"는 분석이 제 성격을 너무 잘 표현했어요. 10년 운세 차트를 보니 2026~2028년에 학문 관련 성취가 강하게 나와 있어서 유학 준비를 계속하기로 마음먹었습니다. 아직 가는 길이지만 확신을 가질 수 있었던 계기가 됐어요.',
    rating: 4,
    highlight: '진로 결정의 확신을 얻음',
  },
  {
    id: 4,
    name: '최유라',
    occupation: '간호사 · 31세',
    date: '2025년 12월',
    image: 'https://readdy.ai/api/search-image?query=asian%20woman%20early%2030s%20kind%20gentle%20expression%20wearing%20light%20blue%20casual%20top%20medium%20length%20wavy%20hair%20natural%20makeup%20warm%20indoor%20background%20soft%20portrait%20photography&width=400&height=400&seq=testimonial-v2-4&orientation=squarish',
    content: '3년 넘게 사귄 남자친구랑 결혼을 고민 중이었는데, 연애운 분석이 너무 공감됐어요. 정재(正財)가 강한 사주라 "안정적인 관계를 선호하고 신중하다"는 분석이 저를 너무 잘 나타냈고요. 점성술 리딩에서 달자리가 게자리로 나왔을 때 "감성적, 가정적"이라는 설명을 읽으면서 혼자 웃었어요. 상담 후에 결혼 결정을 내렸고 올해 초에 식을 올렸습니다. 결과론이긴 하지만 결정하는 데 큰 힘이 됐어요.',
    rating: 5,
    highlight: '결혼 결정에 심리적 확신',
  },
  {
    id: 5,
    name: '정민석',
    occupation: '직장인 · 29세',
    date: '2026년 2월',
    image: 'https://readdy.ai/api/search-image?query=young%20asian%20office%20worker%20man%20late%2020s%20casual%20smart%20appearance%20slightly%20wavy%20hair%20relaxed%20smile%20wearing%20grey%20sweater%20minimal%20clean%20background%20soft%20studio%20portrait%20photography&width=400&height=400&seq=testimonial-v2-5&orientation=squarish',
    content: '이직할지 말지를 6개월 동안 고민만 하다가 친구 추천으로 써봤어요. 정관(正官)이 사주에서 강하게 나타나 "명예와 사회적 지위를 중요시하는 성향"이라는 분석이 왜 제가 연봉보다 회사 브랜드를 더 따지는지 이해하게 해줬어요. 십신 분석이 특히 좋았는데, 단순히 운이 좋다/나쁘다가 아니라 제 성격의 뿌리를 설명해줘서 자기이해에 도움이 됐습니다. 결국 이직했고, 분석대로 안정적인 대기업을 택했어요.',
    rating: 5,
    highlight: '십신 분석으로 자기 성향 명확히 파악',
  },
  {
    id: 6,
    name: '한지수',
    occupation: '소상공인 · 44세',
    date: '2025년 10월',
    image: 'https://readdy.ai/api/search-image?query=asian%20woman%20mid%2040s%20mature%20confident%20look%20warm%20smile%20slight%20wrinkles%20natural%20beauty%20wearing%20elegant%20burgundy%20top%20professional%20appearance%20indoor%20soft%20light%20portrait%20photography&width=400&height=400&seq=testimonial-v2-6&orientation=squarish',
    content: '카페를 하나 더 낼지 고민하면서 운세 확인 차 써봤는데, 예상보다 훨씬 자세해서 놀랐어요. 편재(偏財)가 두드러지게 나온 사주라 "사업적 수완이 있고 기회를 잘 포착한다"는 분석이 주변 사람들이 저한테 늘 하는 말이랑 똑같아서 피식 웃었어요. 다만 2025년은 확장보다 내실을 다지는 시기라고 해서 신중하게 결정했고 내년으로 미뤘어요. 단순히 기운이 좋다/나쁘다가 아니라 이유를 설명해줘서 신뢰가 갔습니다.',
    rating: 4,
    highlight: '사업 확장 결정에 신중함 더해줌',
  },
];
